rs.module("core/ui/controls/newpassword",

    [],

    function () {

        // Initialize password strength 
        function initialize(jsSelectors) {

            var password = $.js(jsSelectors.password);
            var passwordErrorMessage = $.js(jsSelectors.passwordErrorMessage);
            var minimumLength = password.data("min-length");
            var requireMixedCase = password.data("require-mixed-case");
            var requireNumber = password.data("require-number");
            var requireSymbol = password.data("require-symbol");
            var allowedSymbols = password.data("allowed-symbols");

            password.pwstrength({
                common: {
                    onKeyUp: function (evt, data) {
                        $('.password-strength__progress-bar').toggleClass('_visible', $(evt.target).val().length > 0);
                    },
                    invalidCharsRegExp: new RegExp(/[\s,'""<>]/),
                    minChar: minimumLength,
                    maxChar: 20
                },
                rules: {
                    extra: {
                        alphaNumeric: function (options, word, score) {
                            return word.match(/^.*(?=.*\d)(?=.*[a-zA-Z]).*$/) ? 0 : score;
                        },
                        mixedCase: function (options, word, score) {
                            return word.match(/^.*(?=.*[a-z])(?=.*[A-Z]).*$/) ? 0 : score;
                        },
                        symbols: function (options, word, score) {
                            return word.match(new RegExp(`^.*(?=.*[${allowedSymbols}]).*$`)) ? 0 : score;
                        },
                    },
                    scores: {
                        alphaNumeric: -10,
                        mixedCase: -10,
                        symbols: -10,

                        wordNotEmail: -100,
                        wordMinLength: -50,
                        wordMaxLength: -50,
                        wordInvalidChar: -10,
                        wordSimilarToUsername: -100,
                        wordSequences: -50,
                        wordTwoCharacterClasses: 2,
                        wordRepetitions: -25,
                        wordLowercase: 1,
                        wordUppercase: 3,
                        wordOneNumber: 3,
                        wordThreeNumbers: 5,
                        wordOneSpecialChar: 3,
                        wordTwoSpecialChar: 5,
                        wordUpperLowerCombo: 2,
                        wordLetterNumberCombo: 2,
                        wordLetterNumberCharCombo: 2
                    },
                    activated: {
                        alphaNumeric: requireNumber,
                        mixedCase: requireMixedCase,
                        symbols: requireSymbol,

                        wordNotEmail: false,
                        wordMinLength: true,
                        wordMaxLength: false,
                        wordInvalidChar: true,
                        wordSimilarToUsername: false,
                        wordSequences: false,
                        wordTwoCharacterClasses: false,
                        wordRepetitions: false,
                        wordLowercase: true,
                        wordUppercase: true,
                        wordOneNumber: true,
                        wordThreeNumbers: true,
                        wordOneSpecialChar: true,
                        wordTwoSpecialChar: true,
                        wordUpperLowerCombo: true,
                        wordLetterNumberCombo: true,
                        wordLetterNumberCharCombo: true
                    }
                },
                ui: {
                    progressExtraCssClasses: 'password-strength__progress-bar',
                    useVerdictCssClass: true,
                    showErrors: true
                },
                i18n: {
                    t: function (key) {
                        var messages = {
                            alphaNumeric: 'Your password must be alphanumeric',
                            mixedCase: 'Your password must include both upper and lower case characters',
                            symbols: `Your password must include at least one symbol: ${allowedSymbols.replaceAll(",", " ")}`,

                            wordMinLength: `Your password must be at least ${minimumLength} characters long`,
                            wordMaxLength: 'Your password is too long',
                            wordInvalidChar: 'Your password contains an invalid character',
                            wordNotEmail: 'Do not use your email as your password',
                            wordSimilarToUsername: 'Your password cannot contain your username',
                            wordTwoCharacterClasses: 'Use different character classes',
                            wordRepetitions: 'Too many repetitions',
                            wordSequences: 'Your password contains sequences',
                            errorList: 'Errors:',
                            veryWeak: 'Very Weak',
                            weak: 'Weak',
                            normal: 'Normal',
                            medium: 'Medium',
                            strong: 'Strong',
                            veryStrong: 'Very Strong',
                        }

                        return messages[key];
                    }
                }
            });
        }

        // Exported public API
        var exports = {
            initialize
        };

        return exports;
    }
);